export default "__VITE_ASSET__BzCHFDNq__"